import { yup } from '@framework/validation';
import { evaluateExpression } from '../../schema/expressions/evaluate/evaluateExpression';
import { mapReferenceToPath } from '../../schema/expressions/evaluate/mapReferenceToPath';
import { createEvaluationVariables } from '../../schema/expressions/evaluate/variables/IEvaluationVariables';
import { collectExpressionReferences } from '../../schema/expressions/references/collectExpressionReferences';
import { IAssignableExpression } from '../../schema/expressions/repository/assignable/IAssignableExpression';

/**
 * Funzione semplificata che imposta un'espressione come valore di default
 * per uno schema. Non funziona per default di tipo oggetto.
 */
export function setSchemaExpressionDefaultValue(
  schema: yup.AnySchema,
  expression: IAssignableExpression | null | undefined,
) {
  if (!expression) return schema;

  const references = collectExpressionReferences(expression);
  const paths = references.map(r => mapReferenceToPath(r));

  return schema.parentWhen(
    paths,
    (values, schema: yup.AnySchema, context: any) => {
      const variables = createEvaluationVariables(references, values);
      const result = evaluateExpression(expression, { variables });

      // N.B. Utilizzare != null perché il valore può essere un boolean (`false`)
      return result != null ? schema.default(result) : schema;
    },
  );
}
